// @ts-nocheck
import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import marketing from 'assets/img/marketing.svg';
import MuiButton from 'pages/ProjectBudget/DayworkDocket/common/Button';
import { useClientStyles } from '../../Styles';

export default function MarketingBanner() {
  const classes = useClientStyles();
  const theme = useTheme();

  return (
    <>
      <Box
        className={classes.actionCard}
        sx={{
          width: { xs: 'auto', sm: '765px' },
          backgroundColor: 'rgba(243, 246, 251, 1)',
        }}
        my={2}
      >
        <Box
          display="flex"
          flexDirection={{ xs: 'column', sm: 'row' }}
          alignItems="center"
        >
          <Box
            px={{ xs: 4, sm: 3 }}
            py={{ xs: 4, sm: 3 }}
            pr={{ xs: 0, sm: 0 }}
          >
            <Typography variant="h6" mb={1}>
              Civil Construction Management Made Easy
            </Typography>
            <Typography
              variant="body2"
              mb={2}
              sx={{ color: 'rgba(106, 115, 123, 1)' }}
            >
              Field reporting, real-time cost tracking, effortless claims,
              powerful forecasting, and many more.
            </Typography>
            <Typography
              variant="subtitle"
              mb={2}
              sx={{ fontWeight: 500, color: theme.palette.primary.textColor }}
            >
              Want to check everything we do?
            </Typography>
            <Box my={2}>
              <MuiButton
                variant="contained"
                color="primary"
                sx={{
                  margin: ' 0px 10px 10px 0px',
                  textTransform: 'uppercase',
                }}
                href="https://varicon.com.au/"
                target="_blank"
              >
                Learn more about varicon
              </MuiButton>

              <MuiButton
                variant="contained"
                color="primary"
                sx={{ margin: ' 0px 0px 10px 0px' }}
                href="https://varicon.com.au/booking/"
                target="_blank"
              >
                {' '}
                Request a Free Demo
              </MuiButton>
            </Box>
          </Box>

          <img src={marketing} alt="Marketing" />
        </Box>
      </Box>
    </>
  );
}
